<template>
  <div class="home">
    <nav-bar />
    <hero-section />
    <value-section />
    <brands-section />
    <stats-section ref="statsSectionRef"/>
    <promotion-section />
<!--    <app-footer />-->
  </div>
</template>

<script lang="ts">
import { ref, provide } from 'vue'
import NavBar from '@/components/NavBar.vue'
import HeroSection from '@/components/home/HeroSection.vue'
import ValueSection from '@/components/home/ValueSection.vue'
import BrandsSection from '@/components/home/BrandsSection.vue'
import StatsSection from '@/components/home/StatsSection.vue'
import PromotionSection from '@/components/home/PromotionSection.vue'
import { queryAchievementData } from '@/api/home'
// import AppFooter from '@/components/AppFooter.vue'
export default {
  name: 'HomeView',
  components: {
    NavBar,
    HeroSection,
    ValueSection,
    BrandsSection,
    StatsSection,
    PromotionSection
    // AppFooter
  },
  setup () {
    const statsSectionRef = ref()

    const scrollToStats = () => {
      if (statsSectionRef.value?.$el) {
        statsSectionRef.value.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    }

    // 提供滚动方法给子组件
    provide('scrollToStats', scrollToStats)
    return {
      statsSectionRef
    }
  }
}

</script>
